import {ClientProps} from "@/interfaces/client_types.ts";

export function ImportFormProps({formProps} : {formProps?: ClientProps}) {
    if (!formProps) return {}

    return {
        ...formProps
    }
}